import React from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { AuthorizationWrapper } from "../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../core/security/SprintAccessRight";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";
import { ApproveFileRecordDetailsNotificationsDialog } from "./ApproveFileRecordDetailsNotificationsDialog";

export const ApproveFileRecordDetailsNotificationsButton = (): JSX.Element => {
    const { approveFileRecordNotifications } = useFileRecordApi();

    const { fileRecordDetails, setFileRecordDetails } = useFileRecordDetailsState();

    const { isOpen, onClose, onOpen } = useDisclosure();

    const handleConfirmation = async () => {
        await approveFileRecordNotifications({ fileRecordId: fileRecordDetails.id });

        setFileRecordDetails({
            ...fileRecordDetails,
            isNotificationApproved: true
        });

        onClose();
    };

    const isNotificationApproved = fileRecordDetails.isNotificationApproved;

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <CommandBarButton
                text={"Approve notifications"}
                icon={isNotificationApproved ? "CheckboxComposite" : "Ringer"}
                onClick={onOpen}
                disabled={isNotificationApproved}
            />
            <ApproveFileRecordDetailsNotificationsDialog
                confirm={handleConfirmation}
                isOpen={isOpen}
                onClose={onClose}
            />
        </AuthorizationWrapper>
    );
};
